import { useTracking } from 'react-tracking';
import { RouterLink } from '@redux-first-router-link';

import { Grid, Heading, Text } from '@simplywallst/ui-core';

import { CompanyIcon } from '@/components/CompanyIcon';

interface Props {
  websiteUrl: string | null;
  tickerSymbol: string;
  name: string;
  canonicalURL: string;
}

export const CompanyNameWithIcon = ({
  canonicalURL,
  websiteUrl,
  tickerSymbol,
  name,
}: Props) => {
  const { trackEvent } = useTracking();

  return (
    <RouterLink
      noUnderline
      to={canonicalURL}
      onClick={() => {
        trackEvent({
          action: 'click',
          canonicalURL,
        });
      }}
    >
      <Grid templateColumns="max-content auto" gap="8px">
        <CompanyIcon
          website={websiteUrl}
          tickerSymbol={tickerSymbol}
          size={40}
        />
        <Grid rowGap="2px">
          <Heading as="h2" typography="xSmallStrong" color="brand01">
            {tickerSymbol}
          </Heading>
          <Text typography="tiny" color="textSofter" lineClamp={1}>
            {name}
          </Text>
        </Grid>
      </Grid>
    </RouterLink>
  );
};
